module.exports = __webpack_public_path__ + "img/niu.dcf12f10.jpeg";